<template>
  <a-card class="NormSeting">
    <a-tabs v-model="activekey" default-active-key="1">
      <a-tab-pane key="1" tab="常模应用">

      </a-tab-pane>
      <a-tab-pane key="2" tab="常模计算">

      </a-tab-pane>
    </a-tabs>
    <NormApply v-if="activekey == 1" ref="NormApply"></NormApply>
    <NormCompute v-if="activekey == 2" ref="NormCompute"></NormCompute>
  </a-card>
</template>

<script>
import NormApply from "./components/NormApply";//常模应用
import NormCompute from "./components/NormCompute";//常模计算
import $Bus from "@/pages/projectImpl/js/eventBus";

export default {
  name: "NormSeting",
  components: {
    NormApply,
    NormCompute,
  },
  data() {
    return {
      activekey: (this.$route.query.activeKey || 1) + "",
    };
  },
  mounted() {
    let info = this.$store.getters["content/getQuestionGroupInfo"]();
    if (this.$route.query.type === "game") {
      info = this.$store.getters["content/getEvaluationGameInfo"]();
    }
    const breadcrumb = ["首页", "内容中心"];
    if (this.$route.query.type == "game") {
      let classifyTagName = this.$route.query.classifyTag == 1 ? "商用" : "科研";
      let path = this.$route.query.classifyTag == 1 ? "/content/BusinessEvaluation/BusinessEvaluation" : "/content/ScienceEvaluation/index";

      this.$store.commit("account/set_breadcrumb", breadcrumb.concat([
        { name: classifyTagName + "测评游戏", path: path },
        { name: classifyTagName + "测评游戏配置", path: decodeURIComponent(this.$route.query.fullPath) },
        { name: "常模配置" },
      ]));
    }
    if (this.$route.query.type == "questionnaire") {
      this.$store.commit("account/set_breadcrumb", breadcrumb.concat([
        { name: "问卷管理", path: "/content/QuestionnaireManage/QuestionnaireManage" },
        { name: "问卷配置", path: "/content/QuestionnaireManage/QuestionnaireSeting?type=edit" },
        { name: "常模配置" },
      ]));
    }
    if (this.$route.query.type == "question") {
      if (info.contentType === 5) {
        this.$store.commit("account/set_breadcrumb", breadcrumb.concat([
          { name: "亲子游戏管理", path: info.fullPath },
          { name: "亲子游戏配置", path: "/content/ParentingGame/ParentingGameStting?type=edit" },
          { name: "常模配置" },
        ]));
      } else {
        this.$store.commit("account/set_breadcrumb", breadcrumb.concat([
          { name: "题目壳管理", path: "/content/Questiongroup/Questiongroup" },
          { name: "题目壳配置", path: "/content/Questiongroup/QuestiongroupSeting?type=edit" },
          { name: "常模配置" },
        ]));
      }
    }
    this.$nextTick(() => {
      $Bus.$emit("updateTabName", { path: this.$route.path, name: (info.contentName || "") + "常模配置" });
    });
  },
};
</script>

<style scoped lang="less">

</style>
